const BASE = '/api/admin/logistics/returns';

export const ReturnReceptionEndpoints = {
  LIST: BASE,
  LOOKUP: `${BASE}/lookup`,
  GET: (returnRef: string) => `${BASE}/${encodeURIComponent(returnRef)}`,
  RECEIVE: (returnRef: string) => `${BASE}/${encodeURIComponent(returnRef)}/receive`,
  INTAKE: `${BASE}/intake`,
  RESEND_CONFIRMATION: (returnRef: string) =>
    `${BASE}/${encodeURIComponent(returnRef)}/confirmation/resend`,
  RESOLVE: (returnRef: string) => `${BASE}/${encodeURIComponent(returnRef)}/resolve`,
};
